module.exports = __webpack_public_path__ + "static/media/syllabus-overview.39de4cec.md";